export const MaxLvs = [
  { rarity: 5, maxLv: 100 },
  { rarity: 4, maxLv: 90 },
  { rarity: 3, maxLv: 80 },
  { rarity: 2, maxLv: 70 },
  { rarity: 1, maxLv: 60 },
  { rarity: 0, maxLv: 40 },
]

export const LbMaxLvs = [
  { rarity: 5, maxLv: 50 },
  { rarity: 4, maxLv: 40 },
  { rarity: 3, maxLv: 30 },
  { rarity: 2, maxLv: 20 },
  { rarity: 1, maxLv: 10 },
  { rarity: 0, maxLv: 5 },
]

export function sortHeroes(heroes) {
  heroes = [...heroes]
  heroes.sort((p, c) => {
    if (p.heroId < c.heroId) return -1
    if (p.heroId > c.heroId) return 1
    return 0
  })
  heroes.sort((p, c) => {
    if (p.rarity < c.rarity) return 1
    if (p.rarity > c.rarity) return -1
    return 0
  })
  heroes.sort((p, c) => {
    if (+p.asset < +c.asset) return 1
    if (+p.asset > +c.asset) return -1
    return 0
  })
  return heroes
}
